import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import type React from 'react';
import { useEffect, useState } from 'react';

export interface Item {
  value: string;
  label: string;
}

const FilterSelect = (props: any) => {
  const [options, setOptions] = useState<Item[]>([]);
  const [loading, setLoading] = useState(false);

  const loadOptions = async (input: string) => {
    setLoading(true);
    const newOptions = await props.loadOptions(input);
    setOptions(newOptions);
    setLoading(false);
  };

  const handleInputChange = (_event: React.ChangeEvent<{}>, value: string) => {
    loadOptions(value);
  };

  useEffect(() => {
    loadOptions('');
  }, []);

  return (
    <Autocomplete
      options={options}
      getOptionLabel={(option: Item) => option.label}
      onChange={(_, value) => props.onChange(value)}
      onInputChange={handleInputChange}
      loading={loading}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="standard"
          label={props.label}
          required={props.required}
          error={props.error}
          slotProps={{
            input: {
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            },
          }}
        />
      )}
      renderOption={(props, option: Item) => (
        <li {...props} key={props.key}>
          <div className={option.value === (props as any).value ? 'Mui-selected' : ''}>{option.label}</div>
        </li>
      )}
    />
  );
};

export default FilterSelect;
